// copilotPromptModule.js

export const defaultPrompt = `You are a Yellowbrick database SQL expert. Given the following table definitions, column statistics, and a question, generate a SQL query strictly adhering to the SQL:2011 standard that answers the question.

${'${schema}'}

**Question:** ${'${question}'}

Generate only the valid SQL query and no additional explanation. Avoid expressions on the left-hand side of WHERE clause predicates. Never generate SQL with window or aggregate functions in GROUP BY expressions.`;
